import { render, staticRenderFns } from "./draft.vue?vue&type=template&id=050b9115"
import script from "./draft.vue?vue&type=script&lang=js"
export * from "./draft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports